import type { TextDiffSegment } from './model-performance.types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const extractErrorMessage = (error: unknown): string | undefined => {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (isRecord(error)) {
    const messageCandidate = error.message;
    if (typeof messageCandidate === 'string' && messageCandidate.trim()) {
      return messageCandidate;
    }

    const response = error.response;
    if (isRecord(response)) {
      const data = response.data;
      if (isRecord(data)) {
        const nestedMessage = data.message;
        if (typeof nestedMessage === 'string' && nestedMessage.trim()) {
          return nestedMessage;
        }
      }
    }
  }

  return undefined;
};

export const isAssessmentTask = (value: string): value is 'ASR' | 'TTS' =>
  value === 'ASR' || value === 'TTS';

export const getTextDiff = (original: string, generated: string): TextDiffSegment[] => {
  const originalWords = original.split(/\s+/);
  const generatedWords = generated.split(/\s+/);
  const maxLength = Math.max(originalWords.length, generatedWords.length);
  const differences: TextDiffSegment[] = [];

  for (let i = 0; i < maxLength; i++) {
    const origWord = originalWords[i] || '';
    const genWord = generatedWords[i] || '';
    differences.push({
      index: i,
      original: origWord,
      generated: genWord,
      match: origWord.toLowerCase() === genWord.toLowerCase(),
    });
  }

  return differences;
};

export const calculateAccuracyPercent = (original: string, generated: string): number => {
  const diff = getTextDiff(original, generated);
  const matches = diff.filter((d) => d.match).length;
  return diff.length > 0 ? Math.round((matches / diff.length) * 100) : 0;
};

export const parseCsvLines = (lines: string[]) =>
  lines
    .filter((line) => !line.startsWith('Demande') && !line.startsWith('Sender Phone'))
    .map((line) => {
      const parts = line.split(',');
      const fr = parts[0]?.replace(/^"|"$/g, '').trim();
      const text = parts.slice(1).join(',').replace(/^"|"$/g, '').trim();
      return { fr, text };
    });
